export default __webpack_public_path__ + "static/media/bg-news.4efdcbfd.jpg";